import { FinancialStatementPeriod } from 'common/types/financials';
import { BalanceSheetTableData } from './types';

const setColumnsOnBalanceSheet = ({ isBalanceSheet, setColumns, tableData }: { isBalanceSheet: boolean, setColumns: (columns: FinancialStatementPeriod[]) => void, tableData: BalanceSheetTableData }) =>
  isBalanceSheet ? { ...tableData, setColumns } : tableData;

export default setColumnsOnBalanceSheet;
